import { getScltClassName } from "../../../utils/tracking/library";

// This function is used to create a unique hash based on the displayFilter parameter
// for local subject content. Code found on stack overflow.
// https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript
export function hashString(s) {
    return s.split("").reduce((a, b) => {
        a = (a << 5) - a + b.charCodeAt(0);
        return a & a;
    }, 0);
}

export function isLinkVisible(linkVisible) {
    return linkVisible === "true" || (linkVisible && linkVisible !== "false");
}

/**
 * This function generates the tracking class for a section as well as the base stem for card tracking classes
 *
 * @param {number} sectionIndex index of the section the ad is being rendered in
 *
 * @returns {Object} tracking class for section, base stem for card tracking classes
 */
export function getSectionTrackingClass(sectionIndex) {
    return getScltClassName(`section${sectionIndex}`);
}

/**
 * This function takes grid data and adds in the sclt classes for each card based on their position.
 * @param {Array} gridData the array of data items to be rendered by the content grid.
 * @param {number} sectionIndex index of the section the ad is being rendered in
 *
 * @returns {Object} gridData with sclt classes added
 */
export function addCardTrackingClasses(gridData, sectionIndex) {
    const stem = getSectionTrackingClass(sectionIndex);

    return gridData.map((data, cardIndex) => {
        const trackingClass = data.trackingClass || `${stem}card${cardIndex}`;

        return { ...data, trackingClass };
    });
}

/**
 * Check if the current sectionData has content
 *
 * @param {Object} section
 *
 * @returns {boolean} true if current sectionData has content
 */
export function hasContent(section) {
    return section && section.content && section.content.length > 0;
}
